// extracted by mini-css-extract-plugin
export default {"parallax":"style_parallax__JS38L","hidden":"style_hidden__ehJBZ"};